import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var UserOutline = function UserOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.4805C14.5996 12.4805 16.7051 10.1816 16.7051 7.36719C16.7051 4.5957 14.5996 2.39355 12 2.39355C9.41113 2.39355 7.28418 4.62793 7.29492 7.38867C7.30566 10.1924 9.40039 12.4805 12 12.4805ZM12 10.6006C10.5176 10.6006 9.26074 9.19336 9.26074 7.38867C9.25 5.62695 10.5068 4.27344 12 4.27344C13.5039 4.27344 14.7393 5.60547 14.7393 7.36719C14.7393 9.17188 13.4932 10.6006 12 10.6006ZM5.29688 22.4707H18.6924C20.5508 22.4707 21.4424 21.8799 21.4424 20.6123C21.4424 17.6582 17.7578 13.7266 12 13.7266C6.24219 13.7266 2.54688 17.6582 2.54688 20.6123C2.54688 21.8799 3.43848 22.4707 5.29688 22.4707ZM4.96387 20.5908C4.70605 20.5908 4.60938 20.5049 4.60938 20.3115C4.60938 18.668 7.2627 15.6064 12 15.6064C16.7266 15.6064 19.3799 18.668 19.3799 20.3115C19.3799 20.5049 19.2832 20.5908 19.0254 20.5908H4.96387Z"
  })));
};

UserOutline.displayName = 'UserOutline';
export default UserOutline;